import { Controller } from "@hotwired/stimulus";
import Customization from "../customization";
import { ImageBlob } from "../customization/lib";

// Connects to data-controller="site-builder--custom-images--library-file-selector"
export default class extends Controller {
  static targets = ["selected", "title", "save"];
  static outlets = ["cropper"];

  connect() {
    this.imageType = document.body.dataset.imageType;

    const dialog = document.querySelector('.modal');
    if (dialog && dialog.dataset.cropperDetails && dialog.dataset.largerImageUrl && dialog.dataset.originalImageName) {
      const cropperDetails = JSON.parse(dialog.dataset.cropperDetails);
      const largerImageUrl = dialog.dataset.largerImageUrl;
      const originalImageName = dialog.dataset.originalImageName;

      this.cropperOutlet.use(largerImageUrl, originalImageName).then(() => {
        const checkCropper = setInterval(() => {
          if (this.cropperOutlet.cropper) {
            clearInterval(checkCropper);
            this.cropperOutlet.cropper.setData(cropperDetails);
          }
        }, 100);

        setTimeout(() => clearInterval(checkCropper), 5000);
      });

      delete dialog.dataset.cropperDetails;
      delete dialog.dataset.largerImageUrl;
    }
  }

  async apply() {
    this.dataset = this.selectedTarget.dataset;
    await this.cropperOutlet.use(this.dataset.url, this.dataset.title);
    this.element.querySelector('.remove_image').click();
    this.saveTarget.classList.remove('show');
  }

  async render() {
    if (this.cropperOutlet.hasCropped()) {
      let name = this.dataset?.title
        || document.querySelector('.image-view .image-cropper-details')?.getAttribute('data-original-image-name')
        || 'image.png';
      const image = await this.cropperOutlet.getImage({ name });
      const blob = new ImageBlob(image);
      const {url} = blob;
      window.blobs = { ...window.blobs, [this.imageType]: blob };

      Customization.serverUpdate({ [this.imageType]: { url, type: 'direct-upload', name } });
      this.dispatch('applied');
      return;
    }

    if (this.dataset) {
      const url = this.dataset.url;
      const id = this.dataset.id;
      const name = this.dataset.title;
      Customization.serverUpdate({ [this.imageType]: { url, type: 'library', id, name } });
      this.dispatch('applied');
      return;
    }
  }
}
